import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import {Navbar, Nav} from "react-bootstrap"

const Header = ({ siteTitle }) => (

  <Navbar collapseOnSelect expand="lg" bg="light">
    <Navbar.Brand href="/">Toonify</Navbar.Brand>
    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
    <Navbar.Collapse id="responsive-navbar-nav">
      <Nav className="mr-auto">
        <Nav.Link href="/about">About</Nav.Link>
        <Nav.Link href="/faq">FAQ</Nav.Link>
        {/* <Nav.Link href="/coming-soon">Technology</Nav.Link> */}
        <Nav.Link href="https://justinpinkney.github.io/toonify-api-docs/">API</Nav.Link>
        {/* <Nav.Link href="/coming-soon">Contact</Nav.Link> */}
        {/* <Nav.Link href="/coming-soon">Our models</Nav.Link> */}
        {/* <Nav.Link href="/coming-soon">Examples</Nav.Link> */}
      </Nav>
    </Navbar.Collapse>
  </Navbar>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
